import React from 'react';
import { useTranslation } from 'react-i18next';
import { string, bool, func } from 'prop-types';
import useStyles from 'hooks/useStyles';

import Button from 'components/Button';

import styles from './PurchaseButton.scss';

function PurchaseButton({ onClick, price, hasAddOn }) {
  useStyles(styles);

  const { t } = useTranslation(['course']);

  return (
    <Button
      className={styles.root}
      onClick={onClick}
      text={
        hasAddOn
          ? t('footer.purchase_cta1')
          : t('footer.purchase_cta0', { price })
      }
    />
  );
}

PurchaseButton.propTypes = {
  price: string.isRequired,
  hasAddOn: bool.isRequired,
  onClick: func.isRequired,
};

export default PurchaseButton;
